import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faSun, 
  faMoon, 
  faBars, 
  faXmark, 
  faLanguage 
} from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/logo.png';
import '../styles/components/header.css';
import { useTranslation } from 'react-i18next';


function Header() {
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    // Appliquer le thème au chargement et aux changements
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
  }, [isDarkMode]);

  // Écouter les changements de préférence système
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      if (localStorage.getItem('darkMode') === null) {
        setIsDarkMode(e.matches);
      }
    };
    
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  const toggleLanguage = () => {
    const newLang = currentLang === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <header className="header">
      <div className="logo-container">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="MANAGEGLI Logo" className="logo" />
          <span className="logo-text">MANAGEGLI</span>
        </Link>
      </div>

      <button 
        className="mobile-menu-button" 
        onClick={toggleMenu}
        aria-label={t('accessibility.mainMenu')}
      >
        <FontAwesomeIcon 
          icon={isMenuOpen ? faXmark : faBars} 
          className="menu-icon"
        />
      </button>

      <nav className={`navigation ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          <li><Link to="/features" onClick={closeMenu}>{t('navigation.features')}</Link></li>
          <li><Link to="/tutorial" onClick={closeMenu}>{t('navigation.tutorial')}</Link></li>
          <li><Link to="/documentation" onClick={closeMenu}>{t('navigation.documentation')}</Link></li>
          <li><Link to="/contact" onClick={closeMenu}>{t('navigation.contact')}</Link></li>
        </ul>
      </nav>

      <div className="nav-icons">
        <button 
          className="language-toggle"
          onClick={toggleLanguage}
          aria-label={t('accessibility.changeLanguage')}
        >
          <FontAwesomeIcon icon={faLanguage} className="icon" />
          <span>{currentLang.toUpperCase()}</span>
        </button>
        <button 
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label={t('accessibility.toggleTheme')}
        >
          <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} className="icon" />
        </button>
      </div>
    </header>
  );
}

export default Header;

// Example usage in a component


function SomeComponent() {
  const { t } = useTranslation();

  return (
    <div>
      <h1>{t('homepage.hero.title')}</h1>
      <p>{t('homepage.hero.subtitle')}</p>
    </div>
  );
}